import { withInstall } from '@hd-front-end/utils'
import Popconfirm from './src/popconfirm.vue'

import type { SFCWithInstall } from '@hd-front-end/utils'

export const ElPopconfirm: SFCWithInstall<typeof Popconfirm> =
  withInstall(Popconfirm)
export default ElPopconfirm

export * from './src/popconfirm'
